<script setup lang="ts">
import { onMounted, ref } from 'vue'

defineProps<{
  ariaLabelledby?: string
  ariaDescribedby?: string
}>()

const dialogRef = ref<HTMLElement>()

onMounted(() => {
  // Deferred so a closing SDL Modal's focus-trap can't steal focus back to its trigger
  setTimeout(() => dialogRef.value?.focus(), 0)
})
</script>

<template>
  <div
    ref="dialogRef"
    class="modal-backdrop fixed inset-0 outline-none overflow-x-hidden overflow-y-auto z-[200] flex flex-col"
    role="dialog"
    aria-modal="true"
    :aria-labelledby="ariaLabelledby"
    :aria-describedby="ariaDescribedby"
    tabindex="-1"
  >
    <div
      class="app-modal-dialog relative w-auto flex-grow flex flex-col justify-center items-center"
      role="document"
    >
      <slot />
    </div>
  </div>
</template>

<style lang="css">
.modal-backdrop {
  background-color: rgb(0 0 0 / 0.3);
  backdrop-filter: blur(2px);
}
</style>
